<template>
    <div class="flex h-full items-center justify-center">
        <p class="mx-auto rounded bg-black px-4 py-2 text-center text-white">
            <slot />
        </p>
    </div>
</template>